var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canShowTimeline)?_c('section',{attrs:{"id":"timeline"}},[_c('div',{ref:"inner",staticClass:"inner"},[_c('time-scale'),_c('timeline-bars',{on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}}),_c('playhead')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }